import React,{Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import Modal from 'react-bootstrap-modal'

import * as dashboardErrorActions from '../../../actions/dashboardErrorActions'
import moment from "moment/moment"
import $ from "jquery"

import '../style.css';
import Spinner from '../../Shared/Spinner'
import Filters from './Filters'
import Pager from '../../Shared/Pager'
import {CookiesSettings} from '../../../helpers/cookiesHelper'
import SearchInput from '../../Shared/SearchInput'
import ConfirmModal from '../../Shared/ConfirmModal'
import Product from './Product'

let cookiesSetting = new CookiesSettings("dashboardError")

let timer

class Errors extends Component{
    constructor(props){
        super(props);
        let {id} = this.props.match.params;
        let {dashboardError, dashboardErrorActions} = this.props;
        dashboardErrorActions.Get(id, 2, 0, dashboardError.filters, 0, 20);
        
        let showFilters = cookiesSetting.get("showFilters");
        if(showFilters == undefined){
            showFilters = true
            cookiesSetting.set("showFilters",showFilters)
        }

        this.state={
            showFilters:showFilters,
            id:id,
            offerId:null,
            modalDetailsIsOpen:false
        }
    }

    componentDidUpdate(){
        let {dashboardError} = this.props;
        if(dashboardError.needRefresh && !dashboardError.fetching){
            this.funcGetErrors()
        }
    }
    handleToggleFilters() {
        cookiesSetting.set("showFilters",!this.state.showFilters)
        this.setState({
            showFilters: !this.state.showFilters
        });
    }
    handleOnFiltersChange(filters){
        let { dashboardErrorActions } = this.props;

        dashboardErrorActions.FiltersChange(filters);
    }
    handleOnFiltersFieldChange(field,value){
        let { dashboardError } = this.props;

        let filters = dashboardError.filters;

        let newFilters = {
            ...filters,
            [field]:value
        }
        this.handleOnFiltersChange(newFilters)
    }

    handleFiltersReset() {
        let { dashboardErrorActions } = this.props;
        dashboardErrorActions.FiltersReset();
    }
    handleSearchOnChange(e){
        let { dashboardErrorActions } = this.props;

        let value = e.target.value;
        dashboardErrorActions.Change("offerId",value);

        this.setState({
            offerId: value
        });

        clearTimeout(timer);
        timer =  setTimeout(()=>{
            dashboardErrorActions.Change("page",1);
            dashboardErrorActions.Change("total",0);
            dashboardErrorActions.Change("needRefresh",true);
        },600)
    }
    handleFieldChange(field,value){
        let { dashboardErrorActions } = this.props;
        dashboardErrorActions.Change(field,value);
        this.setState({
            id: value
        });
        if(["id","companyId"].indexOf(field) !== -1){
            if(!value){
                dashboardErrorActions.ResetData()
            }else{                
                dashboardErrorActions.Change("needRefresh",true);
            }
        }
    }
    handlePagerChange(pager) {
        let { dashboardErrorActions } = this.props;
        dashboardErrorActions.Change("page",pager.page);
        dashboardErrorActions.Change("needRefresh",true);
    }
    handleCountChange(e) {
        let { dashboardErrorActions } = this.props;
        dashboardErrorActions.ChangeCount(e.target.value);
    }
    funcGetErrors(){
        let {dashboardError,dashboardErrorActions} = this.props;
        dashboardErrorActions.Get(this.state.id, 2, 0, dashboardError.filters,
            (dashboardError.page-1) * dashboardError.size,
            dashboardError.size
        )
    }
    render(){        
        let{dashboardError,profile} = this.props;  
        
        let classNameModal = "big-modal modal-bindings";
        if(this.state.fetching){
            classNameModal += " fetching";
        }
        
        return(
            <div className="content companies-page">
                {
                    dashboardError.fetching ?
                        <Spinner
                            styles={{
                                backgroundColor: "#37474F"
                            }}
                            className="absolute"
                        />
                        : null
                }

                <div className="table-wrapp">
                <div className="datatable-header">
                            <div className="form-horizontal">
                            <div className="row">
                                <div className="col-sm-4">
                                        {
                                            (profile.roles.indexOf("Admin") !== -1) ?
                                                <div className="companies-search">
                                                    <label className=" control-label">Компания</label>
                                                    <SearchInput
                                                        className=""
                                                        apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                        onObjectChange={(obj) =>
                                                            this.handleFieldChange("companyId", obj.id)
                                                        }
                                                        // outObject={this.state.data.City}
                                                        value={this.state.id}
                                                        placeholder="Начните вводить название"
                                                        mapping={{
                                                            id:"id",
                                                            value:"{name} <br> ({url})",
                                                            shownValue:"{name}",
                                                            dataFieldName:"content.companies"
                                                        }}
                                                    />
                                                </div>
                                                :null
                                        }
                                </div>                                
                            </div>
                            </div>
                            <br/>
                            <div className="controls">
                                <div className="left-controls">   
                                    <div className="filter-bnt">
                                        <button type="button" className="btn btn-link" onClick={() => this.handleToggleFilters()}>
                                            Фильтр
                                            {
                                                this.state.showFilters ?
                                                    <i className="fa fa-sort-up"></i>
                                                    : <i className="fa fa-sort-down"></i>
                                            }
                                        </button>
                                    </div>
                                </div>

                                <div className="right-controls">
                                    <div className="count">
                                        <label>
                                            <span>Показывать:</span>
                                        </label>
                                        <select className="select form-control" value={dashboardError.count} onChange={(e) => this.handleCountChange(e)}>
                                            <option value="15">15</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.showFilters ?
                                <Filters
                                    data={dashboardError.filters}
                                    onFiltersChange={(filters) => this.handleOnFiltersChange(filters)}
                                    onReset={() => this.handleFiltersReset()}
                                />
                                :null
                        }
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Артикул</th>
                                <th>Наименование</th>
                                <th>Цена</th>
                                <th>Наличие</th>
                                <th>Ссылка</th> 
                                <th>Активный</th>
                                <th>Дата создания</th>
                                <th>Дата обновления</th>                
                            </tr>
                            </thead>
                            <tbody>
                            {
                                dashboardError.data.length > 0 ?
                                dashboardError.data.map((offers, index) => {
                                    let key = (offers.offerId ? offers.offerId.toString() : "") + index.toString()
                                    return (
                                        <Product
                                            data={offers}
                                            key={key}
                                            companyId={this.state.id}                                                                                                                                   
                                        />
                                    );                                                                
                                    })
                                    : dashboardError.set ?
                                    <tr>
                                        <td colSpan="4">
                                            Нет данных
                                        </td>
                                    </tr>
                                    :null
                            }
                            </tbody>
                        </table>
                        
                    </div>
                    <div className="datatable-footer">
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_3_paginate">
                                {
                                    dashboardError.total > dashboardError.count?
                                        <Pager
                                            pager={{
                                                page: dashboardError.page,
                                                count: dashboardError.count,
                                                total: dashboardError.total
                                            }}
                                            onPageChange={(pager) => this.handlePagerChange(pager)}
                                        />
                                        :null
                                }

                            </div>
                        </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return{
        dashboardError: state.dashboardError,
        profile:state.profile
    }
}

function mapDispatchToProps(dispatch) {
    return{
        dashboardErrorActions:bindActionCreators(dashboardErrorActions,dispatch)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Errors);


// WEBPACK FOOTER //
// ./src/components/Dashboard/Errors/index.jsx